<template>
  <div>
      <div style="width: 100%;margin-bottom: 20px;">
          <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
          </el-breadcrumb>
      </div>

      <!-- 搜索筛选 -->
      <!-- 搜索筛选 -->
      <el-card class="box-card" style="margin-bottom: 20px;">
          <el-form :inline="true" class="user-search" :model="formInline" size="small">
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="handleedit1">新增</el-button>
               
              </el-form-item>
          </el-form>
      </el-card>
      <div class="custom-tree-container">
      <el-tree
      :data="listData"
     
      node-key="id"
   
      :props="defaultProps"
      :expand-on-click-node="false"
    >
      <span class="custom-tree-node" slot-scope="{ data }">
        <span style="margin-right: 100px;width: 200px;">{{ data.title }}</span>
        <span>
         
          <el-button
            type="text"
            size="mini"
            @click="handleedit(data)"
          >
             编辑
          </el-button>
          <el-button
          type="text"
          size="mini"
          @click="handledelete(data)">
              删除
        </el-button>
        </span>
      </span>
    </el-tree>
</div>
   
     <el-dialog
      :close-on-click-modal="false"
      title="设置"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <el-form>
         
          
          <el-form-item label="菜单名称">
             <el-input v-model="editForm.title"></el-input>
              
          </el-form-item>
              <el-form-item label="排序">
          <el-input v-model="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="路径">
          <el-input v-model="editForm.rule"></el-input>  
         </el-form-item>
          <el-form-item label="上级">
            <el-select v-model="editForm.parentId" placeholder="默认全部">
              <el-option :label="item.title" :value='item.id' v-for="(item,index) in listData" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否可见">
            <el-select v-model="editForm.navVisible" placeholder="设置是否可见">
              <el-option label="可见" value='yes'></el-option>
              <el-option label="不可见" value='no'></el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addEdit" >设置</el-button>
       
      </span>
    </el-dialog>


  </div>
</template>

<script>
  

  import {  authMenuList ,addEditAuthMenu , delAuthMenu } from '../../api/pemission.js'

 
 
  // 导出模块
  export default {
     
      // 模块数据
      data() {
          //数据  
          return {       
              loading: true,
              visible: false,
              listData: [], 
              defaultProps: {
                children: 'children',
                label: 'title'
                },         
              dialogVisible: false,
              tagId:'',
              name:'',
              // formInline: {
              //     start: 0,
              //     length: 5,
                 
              // },
               // 分页参数
              //  pageparm: {
              //       currentPage: 1,
              //       pageSize: 5,
              //       total: 10,
              //       start: 0,
              //       length: 5
              //   },
                editForm:{  
                  parentId:'',
                  rule: '',
                  sort:0,
                  title:''
                }
          }
      },


      watch: {},

      methods: {
           // 查询
        //    search() {
        //     this.formInline.start = 0
				// this.pageparm.currentPage = 1
        //       this.getdata(this.formInline)
        //   },
        
          showPop(){
              this.visible = true
              console.log(111)
          },
          // 获得用户数据
          getdata() {
            let param = this.formInline
              authMenuList(param).then(res=>{
                this.saveParams(this.$route.path,this.formInline)
               
                  if (res.code == '200') {
                      this.listData = res.data
                      console.log(this.listData)
                      this.loading = false
                   
                  }
              })
          },
          handleedit(row){
              this.dialogVisible = true
              this.editForm = Object.assign({}, row)
          },
          handleedit1(){
            this.editForm = {}
              this.dialogVisible = true
            
          },
          addEdit(){
             let parentId = this.editForm.parentId?this.editForm.parentId:0

              let param = this.editForm
              param.parentId = parentId
              if(!parentId|| (parentId&&param.rule)   ){
                console.log(param)
                addEditAuthMenu(param).then(res=>{
                  if(res.code==200){
                      this.$message({
                          type: "success",
                          message: '操作成功'
                      })      
                      this.getdata()
                      this.dialogVisible = false
                      this.editForm = {}
                  }
               })
              }else{
                this.$message.error('请按要求填写路径')
              }
            
    
          },
          handledelete(row){
              let msg = '确定删除改菜单吗？'
            this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delAuthMenu(row).then(res=>{
                       
                        if(res.code==200){
                            this.$message({
                                type: "success",
                                message: '删除成功'
                                })
                            this.getdata()
                          }
                     })
                })
          },
            // 分页插件事件
          //   callFather(parm) {
          //     this.pageparm.currentPage  = parm.currentPage
          //       this.pageparm.pageSize =  parm.pageSize 
          //       this.pageparm.start  = parm.currentPage - 1
          //       this.pageparm.length =  parm.pageSize 
          //       this.formInline.start = parm.currentPage - 1
          //       this.formInline.length = parm.pageSize
          //       this.getdata(this.formInline)
          // },
         
      },
      // 创建前状态(里面是操作)
      beforeCreate() { },
      // 创建完毕状态(里面是操作)
      created() {
        this.getParams(this.$route.path)
          this.getdata()         
      },
      // 挂载前状态(里面是操作)
      beforeMount() { },
      // 挂载结束状态(里面是操作)
      mounted() { },
      // 更新前状态(里面是操作)
      beforeUpdate() { },
      // 更新完成状态(里面是操作)
      updated() { },
      // 销毁前状态(里面是操作)
      beforeDestroy() { },
      // 销毁完成状态(里面是操作)
      destroyed() { }
  };
</script>

<style scoped>
  .el-form-item {
      width: 40%;
      box-sizing: border-box;
  }

  .just-start {
      display: flex;
      justify-content: flex-start;
  }

  .marginT20 {
      margin-top: 20px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    padding-right: 8px;
    width:40%;

  }
</style>